import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export const generarSceneCarousel = (nombre) => {
  const scene = new THREE.Scene();
  scene.userData.nombre = nombre;
  const element2 = document.createElement("div");
  // element2.className = "col-md-12 col-lg-12 mt-3 mb-3 mx-auto d-block div-c1";
  element2.className = " div-c1";

  const element = document.createElement("div");
  // element.className = "list-item col-md-4 col-lg-3";
  element.className = "list-item-carousel div-c1";
  element2.appendChild(element);
  const sceneElement = document.createElement("div");
  sceneElement.style.zIndex = "99999999999999999";
  sceneElement.className = "div-c1";

  element.style.zIndex = "10";
  element.appendChild(sceneElement);
  // const descriptionElement = document.createElement("div");
  // descriptionElement.innerText = "Escena principal 2";
  // element.appendChild(descriptionElement);

  // the element that represents the area we want to render the scene
  scene.userData.element = sceneElement;

  const light = new THREE.DirectionalLight(0xffffff, 0.5);
  light.position.set(1, 1, 1);
  //  scene.add(light);
  // console.log("scene es, ", scene);
  // scene.background = new THREE.Color("#CCCCCC");
  const camera = new THREE.PerspectiveCamera(50, 1, 1, 10);
  camera.position.z = 2;
  scene.userData.camera = camera;

  // const controls = new OrbitControls(
  //   scene.userData.camera,
  //   scene.userData.element
  // );
  // controls.minDistance = 2;
  // controls.maxDistance = 5;
  // controls.enablePan = false;
  // controls.enableZoom = true;
  // scene.userData.controls = controls;

  /**
   * Lights
   */
  const directionalLight = new THREE.DirectionalLight("#ffffff", 5);
  directionalLight.position.set(0, 0, 1);
  scene.add(directionalLight);
  // const directionalLight2 = new THREE.DirectionalLight("#ffffff", 3.5);
  // directionalLight2.position.set(0, 0, -4);
  // scene.add(directionalLight2);
  // const directionalLight3 = new THREE.DirectionalLight("#ffffff", 1);
  // directionalLight3.position.set(2, 0, -0.5);
  // scene.add(directionalLight3);
  // const directionalLight4 = new THREE.DirectionalLight("#ffffff", 1);
  // directionalLight4.position.set(-2, 2, -0.5);
  // scene.add(directionalLight4);
  //   const rectAreaLight = new THREE.RectAreaLight(0xffffff, 0, 1, 2);
  //   scene.add(rectAreaLight);
  const ambientLight = new THREE.AmbientLight(0xffffff, 40);
  scene.add(ambientLight);

  return [scene, element2];
};
